import React from 'react';
import { StoryCard } from '../StoryCard';

class InfoCard extends StoryCard {
	render() {
		return <div className="info-card">{super.renderCard()}</div>;
	}
}

export default InfoCard;
